/*
 *
 * ----------------------------------------------- */
jQuery(function ($) {
  $(".btn-show-more-details").on("click", function (event) {
    var $content = $("#recruitment-type");

    $content.toggleClass("active");
    $(this).toggleClass("active");
  });
});
